import React from 'react'
import { Link } from 'react-router-dom'
import config from '../../config.json'
import Translation from '../Translation/cont/Translation'

const SubmenuItem = ({id, name, transId, path}) => {
    return (
        <Link className={"type-link-wrapper " + id} to={`${path}`}>
            <div className="type-link-content">
                <div className="top-wrapper">
                    <div className="icon-wrapper">
                        <div className={"icon " + id}></div>
                    </div>
                </div>
                <div className="text-wrapper">
                    <p className="title-large-light"><Translation id={transId}>{name}</Translation></p>
                </div>
            </div>
        </Link>
    )
}

export default SubmenuItem  